import { ElementRef } from '@angular/core';

import { NgpPopoverPlacement } from 'ng-primitives/popover';

export type HelpMode = 'popover' | 'panel' | 'inline';

// * string or number (treated as px)
export type DimensionValue = string | number;

// * Configuration for help content display
export interface HelpConfig {
  // ! unique key (e.g., 'settings.output.resolution')
  key: string;
  mode: HelpMode;
  placement?: NgpPopoverPlacement;
  title?: string;

  width?: DimensionValue;
  height?: DimensionValue;
  minWidth?: DimensionValue;
  minHeight?: DimensionValue;
  maxWidth?: DimensionValue;
  maxHeight?: DimensionValue;
}

// * Internal representation of a registered help anchor
export interface HelpAnchor {
  // ! unique anchor ID - for mapping triggers to anchors (we can have the same content key in multiple places)
  id: string;
  element: ElementRef<HTMLElement>;
  config: HelpConfig;
}

// * Content loading states
export type HelpContentStatus = 'idle' | 'loading' | 'success' | 'error';

// * Content state for a help key
export interface HelpContentState {
  status: HelpContentStatus;
  content?: string;
  error?: string;
}

// * Default values
export const HELP_DEFAULTS = {
  MODE: 'popover' as HelpMode,
  PLACEMENT: 'top' as NgpPopoverPlacement,
  TRIGGER_OFFSET: 8, // px offset from anchor element
  TITLE: '',
} as const;
